//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "EmptyState",
  props: {
    msg: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
